











import {Vue, Component, Prop} from 'vue-property-decorator';
import {VacationDto} from "@/dto/payroll/VacationDTO";
import moment, {Moment} from "moment-timezone";
import {prettyEnum} from "@/utils/StringUtils";
import Application from "@/state/Application";
import PayrollService from "@/services/payroll/PayrollService";
import {processError} from "@/utils/ComponentUtils";
import DeleteConfirmation from "@/components/payroll/business/DeleteConfirmation.vue";
import VacationService from "@/services/payroll/VacationService";
import {SickLeave} from "@/components/payroll/sickLeave/SickLeave";

@Component({
	methods: {
		moment(inp?: moment.MomentInput, format?: moment.MomentFormatSpecification, language?: string, strict?: boolean): Moment {
			return moment(inp, format, language, strict)
		},
		prettyEnum
	}
})
export default class VacationOptionsModal extends Vue {

	@Prop()
	private vacation!: VacationDto

	@Prop()
	private callback!: () => void

	private delete() {
		Application.startLoading()
		VacationService.deleteVacationRecord(this.vacation.id, this.vacation.employment.id!).then(
			() => {
				this.$modal.hideAll()
				Application.stopLoading()
				this.callback()
			},
			err => processError(err, this)
		)
	}

	private deleteVacation() {
		this.$modal.show(
			DeleteConfirmation,
			{
				onDelete: () => this.delete(),
				targetName: "vacation"
			}
		)
	}


}

